module.exports = __webpack_public_path__ + "media/images/edit-12cc9de0fccfa2fce2ae09498352d828.png";